/**
 * Action to select the participant to be displayed in LargeVideo.
 *
 * {
 *     type: SELECT_LARGE_VIDEO_PARTICIPANT,
 *     participantId: (string|undefined)
 * }.
 */
export const SELECT_LARGE_VIDEO_PARTICIPANT
    = 'SELECT_LARGE_VIDEO_PARTICIPANT';

export const TOGGLE_SIDEBAR_MENU
    = 'TOGGLE_SIDEBAR_MENU';

export const SET_NATIVE_FULLSCREEN
    = 'SET_NATIVE_FULLSCREEN';

/**
 * Action to update the large video full screen state.
 *
 * @returns {{
 *     type: SET_LARGE_VIDEO_FULLSCREEN,
 *     largevideofullscreen: boolean
 * }}
 */
export const SET_LARGE_VIDEO_FULLSCREEN
    = 'SET_LARGE_VIDEO_FULLSCREEN';

/**
 * Action to update the redux store with the current resolution of large video.
 *
 * @returns {{
 *     type: UPDATE_KNOWN_LARGE_VIDEO_RESOLUTION,
 *     resolution: number
 * }}
 */
export const UPDATE_KNOWN_LARGE_VIDEO_RESOLUTION
    = 'UPDATE_KNOWN_LARGE_VIDEO_RESOLUTION';

/**
 * Action to update the redux store with the current media event name of large video.
 *
 * @returns {{
 *     type: UPDATE_LAST_LARGE_VIDEO_MEDIA_EVENT,
 *     name: string
 * }}
 */
export const UPDATE_LAST_LARGE_VIDEO_MEDIA_EVENT
    = 'UPDATE_LAST_LARGE_VIDEO_MEDIA_EVENT';

/**
 * Action to remember the id of the last remote participant who was the dominant
 * speaker, so that the large video can stay stable on that participant once the
 * current dominant speaker stops talking/mutes (instead of jumping around).
 *
 * @returns {{
 *     type: SET_LARGE_VIDEO_LAST_DOMINANT_SPEAKER,
 *     participantId: ?string
 * }}
 */
export const SET_LARGE_VIDEO_LAST_DOMINANT_SPEAKER
    = 'SET_LARGE_VIDEO_LAST_DOMINANT_SPEAKER';

